var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.edit_version_indicator},[(_vm.edit_base_version_id)?_c('p',[_vm._v("Edited Version: "+_vm._s(_vm.edit_base_version_id))]):_vm._e(),_c('p',[_vm._v("Published Version: "+_vm._s(_vm.published_version_id))])])}
var staticRenderFns = []

export { render, staticRenderFns }